import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { useHistory } from "react-router-dom";
import AuthProvider from "../../providers/AuthProvider";
import AuthMachine from "../../machines/AuthMachine";
import Icon from "../Icon";
import Input from "../Input";
import Select from "../Select";
import Button from "../Button";
import { sendData as login } from "../../services/oneClub";
import { createValidator, required } from "../../utils/validation";
import { EDUCATIONAL } from "../../constants/index";
import { UiLogin } from "./Login.style";
/**
 * 登入組件
 */

const Login = ({
  platformName
}) => {
  const {
    useAuthDispatch,
    useAuthState
  } = AuthProvider;
  const {
    eventType: AuthEventType,
    state: AuthStates
  } = AuthMachine;
  const history = useHistory();
  const authDispatch = useAuthDispatch();
  const authState = useAuthState();
  const [state, setState] = useState({
    password: {
      value: "",
      message: ""
    },
    account: {
      value: "",
      message: ""
    },
    edu: "",
    errorMessage: ""
  });

  const onChange = (key, event) => {
    const value = event.target.value;
    setState({ ...state,
      errorMessage: "",
      [key]: {
        value,
        message: ""
      }
    });
  };

  const submit = async () => {
    // let cantSubmit = false;
    const values = {
      account: state.account.value,
      password: state.account.value
    };
    const rules = {
      account: [{
        message: "帳號欄位不得為空",
        validate: required
      }],
      password: [{
        message: "密碼欄位不得為空",
        validate: required
      }]
    };
    const [isPass, errorGroup] = createValidator(values, rules);
    setState({ ...state,
      errorGroup
    });
    if (isPass) return;
    const result = await login(state.account.value, state.password.value);

    if (result.code !== "SUCCESS") {
      setState({ ...state,
        account: {
          value: "",
          message: ""
        },
        password: {
          value: "",
          message: ""
        },
        errorMessage: `登入失敗：${result.message}`
      });
      return;
    }

    authDispatch(AuthEventType.Logging, {
      jwt: result.jwt
    });
  };

  const confirmHandle = () => {
    authDispatch(AuthEventType.SetEducation, {
      chooseEdu: state.edu
    });
  };

  const cancelHandle = () => {
    authDispatch(AuthEventType.LoggingOut);
  };

  useEffect(() => {
    if (authState.value === AuthStates.Idle) {
      setState({ ...state,
        account: {
          value: "",
          message: ""
        },
        password: {
          value: "",
          message: ""
        },
        errorMessage: authState.context.error || ""
      });
    }
  }, [authState.context.error, authState.value]);
  useEffect(() => {
    if (authState.value === AuthStates.LoginDone) {
      history.push("/");
    }
  }, [authState.value]);
  return /*#__PURE__*/React.createElement(UiLogin, null, /*#__PURE__*/React.createElement("div", {
    className: "wrapper"
  }, state.errorMessage && /*#__PURE__*/React.createElement("div", {
    className: "errorMessage"
  }, /*#__PURE__*/React.createElement("i", {
    className: "material-icons"
  }, "cancel"), state.errorMessage), !authState.context.result?.isNewMember ? /*#__PURE__*/React.createElement("div", {
    className: "content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "subTitle"
  }, "Welcome!"), /*#__PURE__*/React.createElement("h1", {
    className: "title"
  }, "\u5357\u4E00\u6578\u4F4D\u8CC7\u6E90\u5165\u5EAB\u5E73\u53F0"), /*#__PURE__*/React.createElement("div", {
    className: "form"
  }, /*#__PURE__*/React.createElement(Input, {
    label: "\u5E33\u865F",
    icon: "account_circle",
    placeholder: "\u8ACB\u8F38\u5165\u5E33\u865F",
    message: state.account && state.account.message,
    value: state.account && state.account.value,
    onChange: e => onChange("account", e)
  }), /*#__PURE__*/React.createElement(Input.Password, {
    label: "\u5BC6\u78BC",
    icon: "account_circle",
    placeholder: "\u8ACB\u8F38\u5165\u5BC6\u78BC",
    message: state.password && state.password.message,
    value: state.password && state.password.value,
    onChange: e => onChange("password", e)
  })), /*#__PURE__*/React.createElement(Button, {
    variant: "blue",
    onClick: submit,
    loading: authState.context.loading
  }, "\u767B\u5165"), /*#__PURE__*/React.createElement("div", {
    className: "links"
  }, /*#__PURE__*/React.createElement("a", {
    href: "#"
  }, "\u5FD8\u8A18\u5BC6\u78BC"), /*#__PURE__*/React.createElement("div", null, "|"), /*#__PURE__*/React.createElement("a", {
    href: "#"
  }, "\u524D\u5F80\u8A3B\u518A \u2192"))) : /*#__PURE__*/React.createElement("div", {
    className: "content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "iconBox"
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "check_circle"
  })), /*#__PURE__*/React.createElement("div", {
    className: "largeTitle"
  }, "\u767B\u5165\u6210\u529F"), /*#__PURE__*/React.createElement("div", null, "\u8ACB\u9078\u64C7\u6240\u5C6C\u5B78\u5236"), /*#__PURE__*/React.createElement("div", {
    className: "prompt"
  }, "\u203B \u4E00\u65E6\u9078\u64C7\u5B8C\u6210\uFF0C\u82E5\u9700\u4FEE\u6539\u8ACB\u6D3D\u7CFB\u7D71\u7BA1\u7406\u54E1\uFF01"), /*#__PURE__*/React.createElement(Select, {
    options: authState.context.result.eduMap && authState.context.result.eduMap.map(item => ({
      name: item.name,
      value: item.code
    })) || EDUCATIONAL,
    value: state.edu,
    onChange: value => setState({
      edu: value
    })
  }), /*#__PURE__*/React.createElement("div", {
    className: "btnBox"
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "blue",
    onClick: confirmHandle
  }, "\u78BA\u8A8D"), /*#__PURE__*/React.createElement(Button, {
    variant: "orange",
    onClick: cancelHandle
  }, "\u53D6\u6D88")))));
};

export default Login;
Login.propTypes = {
  platformName: PropTypes.string
};